import { render, staticRenderFns } from "./confirm-modal.vue?vue&type=template&id=5f564168&scoped=true&"
import script from "./confirm-modal.js?vue&type=script&lang=js&"
export * from "./confirm-modal.js?vue&type=script&lang=js&"
import style0 from "./confirm-modal.scss?vue&type=style&index=0&id=5f564168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f564168",
  null
  
)

export default component.exports